(function() {
  'use strict';

  angular
    .module('admin.permissions.service', [])
    .factory('PermissionService', PermissionService);

  /** @ngInject */
  function PermissionService($http, $q, API) {

    function getProducer(){
        var defer = $q.defer();

        $http.get(API.API_URL + 'admin/producers')
            .success(defer.resolve);

        return defer.promise;
    }

    function getAdministrator(){
        var defer = $q.defer();

        $http.get(API.API_URL + 'admin/administrators')
            .success(defer.resolve);

        return defer.promise;
    }

    function deleteProducer(id){
        var defer = $q.defer();

        $http.delete(API.API_URL + 'admin/producers/' + id)
            .success(defer.resolve);

        return defer.promise;
    }

    function deleteAdministrator(id){
        var defer = $q.defer();

        $http.delete(API.API_URL + 'admin/administrators/' + id)
            .success(defer.resolve);

        return defer.promise;
    }

    function addProducer(model){
        var defer = $q.defer();

        $http.post(API.API_URL + 'admin/producers', model)
            .success(defer.resolve);

        return defer.promise;
    }

    function addAdministrator(model){
        var defer = $q.defer();

        $http.post(API.API_URL + 'admin/administrators', model)
            .success(defer.resolve);

        return defer.promise;
    }

    function updateAdministrator(id, model){
      var defer = $q.defer();

      $http.put(API.API_URL + 'admin/administrators/' + id, model)
          .success(defer.resolve);

      return defer.promise;
    }

    function addModerator(id){
        var defer = $q.defer();

        $http.post(API.API_URL + 'admin/users/' + id + '/moderator')
            .success(defer.resolve);

        return defer.promise;
    }

    function deleteModerator(id){
        var defer = $q.defer();

        $http.delete(API.API_URL + 'admin/users/' + id + '/moderator')
            .success(defer.resolve);

        return defer.promise;
    }

    function addAmbassador(model){
      var defer = $q.defer();

      $http.post(API.API_URL + 'admin/ambassadors', model)
          .success(defer.resolve);

      return defer.promise;
    }

    function deleteAmbassador(id){
      var defer = $q.defer();

      $http.delete(API.API_URL + 'admin/ambassadors/' + id)
          .success(defer.resolve);

      return defer.promise;
    }

    return{
        getAdministrator: getAdministrator,
        getProducer: getProducer,
        deleteProducer: deleteProducer,
        deleteAdministrator: deleteAdministrator,
        addProducer: addProducer,
        addAdministrator: addAdministrator,
        updateAdministrator: updateAdministrator,
        addModerator: addModerator,
        deleteModerator: deleteModerator,
        addAmbassador: addAmbassador,
        deleteAmbassador: deleteAmbassador,
    };

  }

})();
